<template>
    <div v-bind="$attrs">
    <UiContentwrapper class="py-6">
        <UiFullcolumn class="pb-32">            
            <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
            <template v-for="result in results" :key="`${result.type}-${result.handle}`">
            <SearchResultItem v-if="result.type !== 'suggestion'" class="w-full"  :result="result" />            
            </template>    
            </div>        
        </UiFullcolumn>
    
    </UiContentwrapper>
    </div>
</template>

<script setup lang="ts">

import type { searchResult } from '@/composables/search';

const props = defineProps<{
    results: Array<searchResult>;
}>();

import { computed } from 'vue';

const groupedResults = computed(() => {
    return props.results.reduce((groups, result) => {
        if (!groups[result.type]) {
            groups[result.type] = [];
        }
        groups[result.type].push(result);
        return groups;
    }, {} as Record<string, Array<searchResult>>);
});


</script>